<template>
  <div class="profile-page" v-if="d_usrWdm && !d_userLoading">
    <b-row>
      <b-col sm="12" lg="2"></b-col>

      <b-col sm="12" lg="8">
        <!-- PROFILE HEADER -->
        <b-card class="profile-card">
          <b-row>
            <b-col sm="12" md="2" class="text-center">
              <div v-if="d_userProfileData && d_userProfileData.photo_src" style="border-radius: 50%; height: 100px; width: 100px; overflow: hidden; display: flex; align-items: center; justify-content: center; border: 1px solid gray;">
                <img :src="d_userProfileData.photo_src" style="max-width: 100%; max-height: 100%; object-fit: cover;" />
              </div>
              <div v-else class="avatar">
                <span v-if="d_userProfileData && d_userProfileData.firstname && d_userProfileData.lastname">
                  {{ d_userProfileData.firstname.toUpperCase().charAt(0) }}{{ d_userProfileData.lastname.toUpperCase().charAt(0) }}
                </span>
              </div>
            </b-col>

            <b-col sm="12" md="10">
              <h3 class="profile-name" v-if="d_userProfileData && d_userProfileData.firstname && d_userProfileData.lastname">
                <span v-if="d_userProfileData && d_userProfileData.title" >
                  {{ d_userProfileData.title.toUpperCase() }} 
                </span>
                {{ d_userProfileData.firstname.toUpperCase() }} {{ d_userProfileData.lastname.toUpperCase() }}
              </h3>

              <div class="profile-mail" style="margin-bottom: 20px;">
                <i>{{ d_username }}</i>
              </div>

              <div class="profile-mail" v-if="d_userProfileData && d_userProfileData.mail">
                {{ StoreLangTranslation.data['mail'][StoreLang] }}: {{ d_userProfileData.mail }}
              </div>

              <div class="profile-mail" v-if="d_userProfileData && d_userProfileData.phone">
                {{ StoreLangTranslation.data['phone_number'][StoreLang] }}: {{ d_userProfileData.phone }}
              </div>

              <!-- <div class="profile-birth" v-if="d_userProfileData && d_userProfileData.date_of_birth">
               {{ d_userProfileData.date_of_birth }}
              </div> -->

              <div class="profile-params" v-if="d_sortedList.filter(item => item.type === 'dataset').length > 0">
                {{ StoreLangTranslation.data['dataset_count'][StoreLang] }}: <strong>{{ d_sortedList.filter(item => item.type === 'dataset').length }}</strong>
              </div>

              <div class="profile-params" v-if="d_sortedList.filter(item => item.type === 'article').length > 0">
                {{ StoreLangTranslation.data['article_count'][StoreLang] }}: <strong>{{ d_sortedList.filter(item => item.type === 'article').length }}</strong>
              </div>

              <div class="profile-params" v-if="d_coAuthors.length > 0">
                {{ StoreLangTranslation.data['co_author_count'][StoreLang] }}: <strong>{{ d_coAuthors.length }}</strong>
              </div>

              <div class="social-icons">
                <a v-if="d_userProfileData && d_userProfileData.website" :href="d_userProfileData.website" target="_blank"><i class="fa fa-globe"></i></a>
                <a v-if="d_userProfileData && d_userProfileData.linkedin" :href="d_userProfileData.linkedin" target="_blank"><i class="fa fa-linkedin"></i></a>
                <a v-if="d_userProfileData && d_userProfileData.facebook" :href="d_userProfileData.facebook" target="_blank"><i class="fa fa-facebook"></i></a>
                <a v-if="d_userProfileData && d_userProfileData.twitter" :href="d_userProfileData.twitter" target="_blank"><i class="fa fa-twitter"></i></a>
                <a v-if="d_userProfileData && d_userProfileData.instagram" :href="d_userProfileData.instagram" target="_blank"><i class="fa fa-instagram"></i></a>
                <a v-if="d_userProfileData && d_userProfileData.youtube" :href="d_userProfileData.youtube" target="_blank"><i class="fa fa-youtube"></i></a>
                <a v-if="d_userProfileData && d_userProfileData.orcid_id" :href="'https://orcid.org/' + d_userProfileData.orcid_id" target="_blank" class="orcid">
                  <img src="@/icon/orcid_id.png" style="width: 1.2em;">
                </a>
              </div>

              <!-- <div class="social-icons">
                <a v-if="d_userProfileData" :href="d_userProfileData.website" target="_blank"><i class="fa fa-globe"></i></a>
                <a v-if="d_userProfileData" :href="d_userProfileData.linkedin" target="_blank"><i class="fa fa-linkedin"></i></a>
                <a v-if="d_userProfileData" :href="d_userProfileData.facebook" target="_blank"><i class="fa fa-facebook"></i></a>
                <a v-if="d_userProfileData" :href="d_userProfileData.twitter" target="_blank"><i class="fa fa-twitter"></i></a>
                <a v-if="d_userProfileData" :href="d_userProfileData.instagram" target="_blank"><i class="fa fa-instagram"></i></a>
                <a v-if="d_userProfileData" :href="d_userProfileData.youtube" target="_blank"><i class="fa fa-youtube"></i></a>
                <a v-if="d_userProfileData" :href="'https://orcid.org/' + d_userProfileData.orcid_id" target="_blank" class="orcid">ORCID</a>
              </div> -->
            </b-col>
            <!-- <b-col sm="12" md="5">
            </b-col> -->
          </b-row>
          <b-row v-if="d_userProfileData.about_me && d_userProfileData.about_me.length > 0">
            <b-col sm="12" md="2">
            </b-col>
            <b-col sm="12" md="10">
              <div style="margin-top: 10px;">
                <strong>{{ StoreLangTranslation.data['about'][StoreLang] }}</strong>
              </div>
              <template v-for="(about_item, about_index) in d_userProfileData.about_me">
                <div>
                  {{ about_item.note }}
                </div>
                <hr v-if="about_index != d_userProfileData.about_me.length - 1"/>
              </template>
            </b-col>
          </b-row>
          <div style="text-align: center; margin-top: 5px;">
            <span @click="d_showTab = 'overview'" :style="d_showTab === 'overview' ? 'text-decoration: underline !important; margin-right: 20px; cursor: pointer; color: blue; font-weight: bolder !important;' : 'margin-right: 20px; cursor: pointer; color: blue; font-weight: normal !important;'">
              {{ StoreLangTranslation.data['overview'][StoreLang] }}
            </span>
            <span v-if="d_userDatasetAndArticleList.dataset_list.length > 0 || d_userDatasetAndArticleList.article_list.length > 0" @click="d_showTab = 'publications'" :style="d_showTab === 'publications' ? 'text-decoration: underline !important; cursor: pointer; color: blue; font-weight: bolder; !important' : 'cursor: pointer; color: blue; font-weight: normal !important;'">
              {{ StoreLangTranslation.data['publications'][StoreLang] }}
            </span>
          </div>
        </b-card>


        <template v-if="d_showTab === 'overview'">
          <b-spinner v-if="d_datasetAndArticleListLoading" variant="primary" />
          <b-row v-else>
            <b-col :cols="StoreDevice.isMobile ? '12' : '4'">



              <div v-if="StoreDevice.isMobile && (d_researchInterests.length > 0 || d_coAuthors.length > 0)" style="cursor: pointer;">
                <b-card class="interests-card">
                  <b-row align-v="center">
                    <b-col cols="12" md="12" style="text-align: center;">
                      <span @click="d_overViewTab = 'recent_activities'" :style="d_overViewTab === 'recent_activities' ? 'text-decoration: underline !important; margin-right: 20px; cursor: pointer; color: blue; font-weight: bolder !important;' : 'margin-right: 20px; cursor: pointer; color: blue; font-weight: normal !important;'">
                        {{ StoreLangTranslation.data['recent_activities'][StoreLang] }}
                      </span>
                      <span @click="d_overViewTab = 'interests_and_authors'" :style="d_overViewTab === 'interests_and_authors' ? 'text-decoration: underline !important; cursor: pointer; color: blue; font-weight: bolder; !important' : 'cursor: pointer; color: blue; font-weight: normal !important;'">
                        {{ StoreLangTranslation.data['interests_and_authors'][StoreLang] }}
                      </span>
                    </b-col>
                  </b-row>
                </b-card>
              </div>



              <b-card class="interests-card" v-if="(!StoreDevice.isMobile || d_overViewTab === 'interests_and_authors') && d_researchInterests.length > 0">
                <b-row align-v="center">
                  <b-col cols="12" md="12">
                    <h3>
                      {{ StoreLangTranslation.data['research_interests'][StoreLang] }}
                    </h3>
                    <hr/>
                    <div v-for="research_interest in d_researchInterests" v-if="research_interest['lang'] && research_interest['lang'][StoreLang]">
                      <i class="fa fa-asterisk" style="margin-right: 5px;"></i> {{ research_interest['lang'][StoreLang] }}
                      
                    </div>

                    
                  </b-col>
                </b-row>
              </b-card>

              <b-card class="co-author-card" v-if="(!StoreDevice.isMobile || d_overViewTab === 'interests_and_authors') && d_coAuthors.length > 0">
                <b-row>
                  <b-col cols="12" md="12">
                    <h3>
                      {{ StoreLangTranslation.data['co_authors'][StoreLang] }}
                    </h3>
                    <hr/>
                    <div v-for="co_author in d_coAuthors" v-if="co_author.author_firstname && co_author.author_lastname" style="font-size: 14px !important;">
                      <i class="fa fa-user" style="margin-right: 5px;"></i>
                      <span v-if="co_author && co_author.author_title" >
                        {{ co_author.author_title }} 
                      </span>
                      {{ co_author.author_firstname }} {{ co_author.author_lastname }} 
                      <small v-if="co_author && co_author.author_title" >
                        - {{ co_author.author_institution[StoreLang] }} 
                      </small>

                      <a v-if="co_author.author_orcid_id" :href="'https://orcid.org/' + co_author.author_orcid_id" target="_blank" class="orcid">
                        <img src="@/icon/orcid_id.png" style="width: 1.2em;">
                      </a>
                      <hr/>
                    </div>

                    
                  </b-col>
                </b-row>
              </b-card>

            </b-col>
            <b-col :cols="StoreDevice.isMobile ? '12' : '8'">

              <b-card style="border: none;" v-if="(!StoreDevice.isMobile || d_overViewTab === 'recent_activities') && (d_userDatasetAndArticleList.dataset_list.length > 0 || d_userDatasetAndArticleList.article_list.length > 0)">
                <h3>
                  {{ StoreLangTranslation.data['recent_activities'][StoreLang] }}
                </h3>
                <div v-for="sorted_list_item in d_sortedList">
                  <b-card class="content-card" v-if="sorted_list_item.type == 'dataset'">
                    <template #header>
                      <div class="card-type-header dataset-header">
                        {{ StoreLangTranslation.data['dataset'][StoreLang] }}
                      </div>
                    </template>

                    <!-- TITLE -->
                    <h5 v-if="sorted_list_item.raw.wdmr.data['0']['1'] && sorted_list_item.raw.wdmr.data['0']['1'].lang && sorted_list_item.raw.wdmr.data['0']['1'].lang[StoreLang]">
                      {{ sorted_list_item.raw.wdmr.data['0']['1'].lang[StoreLang] }}
                      <a v-if="sorted_list_item.raw.wdmr.id" :href="f_didLink(sorted_list_item.raw.wdmr.id)" target="_blank">
                        <i class="fa fa-external-link"></i>
                      </a>
                    </h5>

                    <!-- SUBTITLE -->
                    <div class="text-muted mb-2" v-if="sorted_list_item.raw.wdmr.data['0']['10'] && sorted_list_item.raw.wdmr.data['0']['10'].val">
                      {{ sorted_list_item.raw.wdmr.data['0']['10'].val }}
                    </div>

                    <!-- AUTHORS -->
                    <div class="mt-3" v-if="sorted_list_item.raw.wdmr.data['0']['57'] && sorted_list_item.raw.wdmr.data['0']['57'].list && sorted_list_item.raw.wdmr.data['0']['57'].list.length">
                      <!-- <ul class="mt-1">
                        <li v-for="(author, i) in sorted_list_item.raw.wdmr.data['0']['57'].list" :key="i" v-if="author && author['58'] && author['59']">
                          
                          <span v-if="author['60'] && author['60'].val">
                            {{ author['60'].val }}
                          </span>
                          {{ author['58'].val }} {{ author['59'].val }}
                          <small v-if="author['62'] && author['62'].val" class="text-muted">
                            – {{ author['62'].lang[StoreLang] }}
                          </small>
                          <a v-if="author['63'] && author['63'].val" :href="'https://orcid.org/' + author['63'].val" target="_blank">ORCID</a>
                        </li>
                      </ul> -->
                      <div v-for="(author, i) in sorted_list_item.raw.wdmr.data['0']['57'].list" :key="i" v-if="author && author['58'] && author['59']" style="font-size: 14px !important;">
                        <i class="fa fa-user" style="margin-right: 5px;"></i>
                        <span v-if="author['60'] && author['60'].val">
                          {{ author['60'].val }}
                        </span>
                        {{ author['58'].val }} {{ author['59'].val }}
                        <small v-if="author['62'] && author['62'].val" class="text-muted">
                          – {{ author['62'].lang[StoreLang] }}
                        </small>
                        <a v-if="author['63'] && author['63'].val" :href="'https://orcid.org/' + author['63'].val" target="_blank">
                          <img src="@/icon/orcid_id.png" style="width: 1.2em;">
                        </a>
                      </div>
                    </div>

                    <!-- ABSTRACT -->
                    <div class="abstract" v-if="sorted_list_item.raw.wdmr.data['0']['39'] && sorted_list_item.raw.wdmr.data['0']['39'].lang && sorted_list_item.raw.wdmr.data['0']['39'].lang[StoreLang]" v-html="sorted_list_item.raw.wdmr.data['0']['39'].lang[StoreLang]"></div>

                    <!-- DATE -->
                    <div class="date" v-if="sorted_list_item.dateStr">
                      {{ sorted_list_item.dateStr.split('T')[0] }}
                    </div>

                  </b-card>

                  <b-card class="content-card" v-if="sorted_list_item.type == 'article'">
                    <template #header>
                      <div class="card-type-header article-header">
                        {{ StoreLangTranslation.data['article'][StoreLang] }}
                      </div>
                    </template>

                    <!-- TITLE -->
                    <h5 v-if="sorted_list_item.raw.article['49'] && sorted_list_item.raw.article['49'].val">
                      {{ sorted_list_item.raw.article['49'].val }}
                      <a v-if="sorted_list_item.raw.article['50'] && sorted_list_item.raw.article['50'].val" :href="sorted_list_item.raw.article['50'].val" target="_blank">
                        <i class="fa fa-external-link"></i>
                      </a>
                    </h5>

                    <!-- JOURNAL -->
                    <div class="text-muted" v-if="sorted_list_item.raw.article['48'] && sorted_list_item.raw.article['48'].val">
                      {{ sorted_list_item.raw.article['48'].val }}
                    </div>

                    <!-- AUTHORS -->
                    <div class="mt-3" v-if="sorted_list_item.raw.article['66'] && sorted_list_item.raw.article['66'].list && sorted_list_item.raw.article['66'].list.length">
                      <!-- <ul class="mt-1">
                        <li v-for="(author, i) in sorted_list_item.raw.article['66'].list" :key="i" v-if="author && author['67'] && author['68']">
                          <span v-if="author['69'] && author['69'].val">
                            {{ author['69'].val }}
                          </span>
                          {{ author['67'].val }} {{ author['68'].val }}
                          <small v-if="author['71'] && author['71'].val" class="text-muted">
                            – {{ author['71'].lang[StoreLang] }}
                          </small>
                          <a v-if="author['72'] && author['72'].val" :href="'https://orcid.org/' + author['72'].val" target="_blank">ORCID</a>
                        </li>
                      </ul> -->
                      <div v-for="(author, i) in sorted_list_item.raw.article['66'].list" :key="i" v-if="author && author['67'] && author['68']" style="font-size: 14px !important;">
                        <i class="fa fa-user" style="margin-right: 5px;"></i>
                        <span v-if="author['69'] && author['69'].val">
                            {{ author['69'].val }}
                          </span>
                          {{ author['67'].val }} {{ author['68'].val }}
                          <small v-if="author['71'] && author['71'].val" class="text-muted">
                            – {{ author['71'].lang[StoreLang] }}
                          </small>
                          <a v-if="author['72'] && author['72'].val" :href="'https://orcid.org/' + author['72'].val" target="_blank">
                            <img src="@/icon/orcid_id.png" style="width: 1.2em;">
                          </a>
                      </div>
                    </div>

                    <!-- DATE -->
                    <div class="date" v-if="sorted_list_item.dateStr">
                      {{ sorted_list_item.dateStr.split('T')[0] }}
                    </div>

                  </b-card>
                </div>
              </b-card>
            </b-col>
          </b-row>
        </template>

        <template v-if="d_showTab === 'publications'">
          
          <!-- TABS -->
          <b-tabs card class="profile-tabs">

            <!-- DATASET LIST -->
            <b-tab :active="d_tabType === 'dataset_list'" @click="d_tabType = 'dataset_list'">
              <template #title>
                {{ StoreLangTranslation.data['dataset_list'][StoreLang] }}
              </template>

              <b-spinner v-if="d_datasetAndArticleListLoading" variant="primary" />

              <b-row v-else>
                <b-col cols="12" v-for="(item, index) in d_userDatasetAndArticleList.dataset_list" :key="index">
                  <b-card class="content-card" v-if="item && item.wdmr && item.wdmr.data && item.wdmr.data['0']">

                    <!-- TITLE -->
                    <h5 v-if="item.wdmr.data['0']['1'] && item.wdmr.data['0']['1'].lang && item.wdmr.data['0']['1'].lang[StoreLang]">
                      {{ item.wdmr.data['0']['1'].lang[StoreLang] }}
                      <a v-if="item.wdmr.id" :href="f_didLink(item.wdmr.id)" target="_blank">
                        <i class="fa fa-external-link"></i>
                      </a>
                    </h5>

                    <!-- SUBTITLE -->
                    <div class="text-muted mb-2" v-if="item.wdmr.data['0']['10'] && item.wdmr.data['0']['10'].val">
                      {{ item.wdmr.data['0']['10'].val }}
                    </div>

                    <!-- AUTHORS -->
                    <div class="mt-3" v-if="item.wdmr.data['0']['57'] && item.wdmr.data['0']['57'].list && item.wdmr.data['0']['57'].list.length">
                      <ul class="mt-1">
                        <li v-for="(author, i) in item.wdmr.data['0']['57'].list" :key="i" v-if="author && author['58'] && author['59']">
                          <span v-if="author['60'] && author['60'].val">
                            {{ author['60'].val }}
                          </span>
                          {{ author['58'].val }} {{ author['59'].val }}
                          <small v-if="author['62'] && author['62'].val" class="text-muted">
                            – {{ author['62'].lang[StoreLang] }}
                          </small>
                          <a v-if="author['63'] && author['63'].val" :href="'https://orcid.org/' + author['63'].val" target="_blank">
                            <img src="@/icon/orcid_id.png" style="width: 1.2em;">
                          </a>
                        </li>
                      </ul>
                    </div>

                    <!-- ABSTRACT -->
                    <div class="abstract" v-if="item.wdmr.data['0']['39'] && item.wdmr.data['0']['39'].lang && item.wdmr.data['0']['39'].lang[StoreLang]" v-html="item.wdmr.data['0']['39'].lang[StoreLang]"></div>

                    <!-- DATE -->
                    <div class="date" v-if="item.wdmr.created_at">
                      {{ item.wdmr.created_at.split('T')[0] }}
                    </div>

                  </b-card>
                </b-col>

                <b-col v-if="!d_userDatasetAndArticleList.dataset_list.length">
                  {{ StoreLangTranslation.data['dataset_not_found'][StoreLang] }}
                </b-col>
              </b-row>
            </b-tab>

            <!-- ARTICLE LIST -->
            <b-tab :active="d_tabType === 'article_list'" @click="d_tabType = 'article_list'">
              <template #title>
                {{ StoreLangTranslation.data['article_list'][StoreLang] }}
              </template>

              <b-spinner v-if="d_datasetAndArticleListLoading" variant="primary" />

              <b-row v-else>
                <b-col cols="12" v-for="(item, index) in d_userDatasetAndArticleList.article_list" :key="index">
                  <b-card class="content-card" v-if="item && item.article">

                    <!-- TITLE -->
                    <h5 v-if="item.article['49'] && item.article['49'].val">
                      {{ item.article['49'].val }}
                      <a v-if="item.article['50'] && item.article['50'].val" :href="item.article['50'].val" target="_blank">
                        <i class="fa fa-external-link"></i>
                      </a>
                    </h5>

                    <!-- JOURNAL -->
                    <div class="text-muted" v-if="item.article['48'] && item.article['48'].val">
                      {{ item.article['48'].val }}
                    </div>

                    <!-- AUTHORS -->
                    <div class="mt-3" v-if="item.article['66'] && item.article['66'].list && item.article['66'].list.length">
                      <ul class="mt-1">
                        <li v-for="(author, i) in item.article['66'].list" :key="i" v-if="author && author['67'] && author['68']">
                          <span v-if="author['69'] && author['69'].val">
                            {{ author['69'].val }}
                          </span>
                          {{ author['67'].val }} {{ author['68'].val }}
                          <small v-if="author['71'] && author['71'].val" class="text-muted">
                            – {{ author['71'].lang[StoreLang] }}
                          </small>
                          <a v-if="author['72'] && author['72'].val" :href="'https://orcid.org/' + author['72'].val" target="_blank">
                            <img src="@/icon/orcid_id.png" style="width: 1.2em;">
                          </a>
                        </li>
                      </ul>
                    </div>

                  </b-card>
                </b-col>

                <b-col v-if="!d_userDatasetAndArticleList.article_list.length">
                  {{ StoreLangTranslation.data['article_not_found'][StoreLang] }}
                </b-col>
              </b-row>
            </b-tab>

          </b-tabs>
        </template>


      </b-col>

      <b-col sm="12" lg="2"></b-col>
    </b-row>
  </div>
</template>


<script>

import { ClsUser } from '@/wam/modules/user';

import { API_BASE_URL } from '@/config';
import { ServiceFunctions } from '@/wam/modules/service';
import { ClsWdm } from '@/wam/modules/wdm';
import { WisdomRegex } from '@/public/WisdomRegex';
import store from '@/store';
import {
  default as Page404
} from '@/wam/components/widgets/Page404';
import {
  default as Login
} from '@/wam/views/login';
import { mapGetters } from 'vuex';
export default {
  name: 'user_settings',
  computed: mapGetters({
    StoreDevice: 'StoreDevice',
    StoreFrontendSettings: 'StoreFrontendSettings',
    StoreLang: 'StoreLang',
    StoreLangTranslation: 'StoreLangTranslation',
    StoreMenuData: 'StoreMenuData',
    StoreLangList: 'StoreLangList',
  }),
    components: {
    Page404,
    Login,
  },
  props: {},
  data () {
    return {
      d_usrWdm: '',
      d_username: '',
      d_userProfileData: {
        'firstname': '',
        'lastname': '',
        'date_of_birth': '',
        'gender': 0,
        'mail': '',
        'phone': '',
        'about_me': [],
        'cover_photo': '',
        'active_lang': 0,
        'facebook': '',
        'instagram': '',
        'linkedin': '',
        'twitter': '',
        'website': '',
        'youtube': '',
        'orcid_id': '',
        'title': '',
        'photo_src': '',
      },
      d_userDatasetAndArticleList: {
        'dataset_list': [],
        'article_list': []
      },
      d_userLoading: false,
      d_datasetAndArticleListLoading: false,
      d_tabType: 'dataset_list',
      d_showTab: 'overview',
      d_coAuthors: [],
      d_researchInterests: [],
      d_timeTypeIndexList: [],
      d_sortedList: [],
      d_overViewTab: 'recent_activities',
      // d_imageSrc: '',
    };
  },
  created: function () {
    ClsWdm.getLayerWdm('usr').then(resp_wdm_data => { this.d_usrWdm = resp_wdm_data; });
    this.d_username = this.$route.query.u;
    if (this.d_username) {
      this.f_getUserProfile();
    } else {
      this.$router.push({ path: this.StoreLangTranslation.data['page_404_path'][this.StoreLang], query: {} });
    }
    
    
  },
  beforeMount () {},
  mounted: function () {},
  methods: {
    f_didLink: function (wdmr_id) {
      const origin = window.location.origin;
      const newPath = '/dataset?did=' + wdmr_id;
      const newUrl = origin + newPath;
      return newUrl;
    },
    f_getUserProfile: function () {
      let query = 'username=' + this.d_username;
      let data = {};
      this.d_userLoading = true;
      ServiceFunctions.user_profile_get(query, data)
        .then(resp => {
          this.d_userLoading = false;
          // console.log("resp.data")
          // console.log(resp.data)
          if (resp.data.status_code.substring(resp.data.status_code.length - 3, resp.data.status_code.length) == '000') {
            if (resp.data.user_profile) {
              this.d_userProfileData = resp.data.user_profile;
              // if (this.d_userProfileData['cover_photo']) {
              //   this.f_getProfileDoc(this.d_userProfileData['cover_photo']);
              // }
              this.f_getUserDatasetAndArticleList(); 
            } else {
              this.$router.push({ path: this.StoreLangTranslation.data['page_404_path'][this.StoreLang], query: {} });
            }
          } else {
            alert(resp.data.status_code + ' = ' + resp.data.status_message);
          }
        });
    },
    // f_getProfileDoc: function (document_id) {
    //   let query = 'user_client_id=' + this.d_username;
    //   query += '&document_id=' + document_id;
    //   let data = {};
    //   ServiceFunctions.document_get_from_db(query, data)
    //     .then(resp => {
    //       if (resp.data.doc && resp.data.doc_extension) {
    //         this.d_imageSrc = 'data:image/' + resp.data.doc_extension + ';base64,' + resp.data.doc
    //       } else {
    //         let txt = 'status_code = ' + resp.data.status_code + '\n';
    //         txt += 'status_message = ' + resp.data.status_message;
    //         alert(txt);
    //       }
    //     });
    // },
    f_mergeAndSortByDate: function () {
      this.d_sortedList = [];
      const sorted_list = [];

      // Dataset'leri normalize et
      for (var i = 0; i < this.d_userDatasetAndArticleList.dataset_list.length; i++) {
        var ds = this.d_userDatasetAndArticleList.dataset_list[i];

        var dateStr = null;
        if (
          ds &&
          ds.wdmr &&
          ds.wdmr.data &&
          ds.wdmr.data["0"] &&
          ds.wdmr.data["0"]["77"] &&
          ds.wdmr.data["0"]["77"].val
        ) {
          dateStr = ds.wdmr.data["0"]["77"].val;
        }

        sorted_list.push({
          'type': "dataset",
          'raw': ds,
          'dateStr': dateStr,
          'dateObj': dateStr ? new Date(dateStr) : null
        });
      }

      // Article'ları normalize et
      for (var j = 0; j < this.d_userDatasetAndArticleList.article_list.length; j++) {
        var art = this.d_userDatasetAndArticleList.article_list[j];

        var artDateStr = null;
        if (
          art &&
          art.article &&
          art.article["73"] &&
          art.article["73"].val
        ) {
          artDateStr = art.article["73"].val;
        }

        sorted_list.push({
          'type': "article",
          'raw': art,
          'dateStr': artDateStr,
          'dateObj': artDateStr ? new Date(artDateStr) : null
        });
      }

      // Tarihe göre sırala (DESC)
      sorted_list.sort(function (a, b) {
        if (!a.dateObj && !b.dateObj) return 0;
        if (!a.dateObj) return 1;
        if (!b.dateObj) return -1;

        return b.dateObj - a.dateObj;
      });

      this.d_sortedList = sorted_list;
      // console.log('d_sortedList: ',this.d_sortedList)
    },
    f_getUserDatasetAndArticleList: function () {
      let query = 'username=' + this.d_username;
      let data = {};
      this.d_datasetAndArticleListLoading = true;
      ServiceFunctions.dataset_and_article_list_authored_by_user(query, data)
        .then(resp => {
          this.d_datasetAndArticleListLoading = false;
          // console.log("resp.data")
          // console.log(resp.data)
          if (resp.data.status_code.substring(resp.data.status_code.length - 3, resp.data.status_code.length) == '000') {
            this.d_userDatasetAndArticleList.dataset_list = resp.data.dataset_list;
            this.d_userDatasetAndArticleList.article_list = resp.data.article_list;
            if (this.d_userDatasetAndArticleList.dataset_list.length == 0 && this.d_userDatasetAndArticleList.article_list.length > 0) {
              this.d_tabType = 'article_list';
            }
            this.f_mergeAndSortByDate();
            this.d_coAuthors = [];
            this.d_researchInterests = [];

            if (this.d_userDatasetAndArticleList.dataset_list.length > 0) {
              for (let dataset_item of this.d_userDatasetAndArticleList.dataset_list) {
                let bundle_group = {};
                try {
                  bundle_group = dataset_item.wdmr.data['0']['10'];
                } catch {}
                if (bundle_group.val) {
                  let already_in = false;
                  for (let interest_item of this.d_researchInterests) {
                    if (interest_item.val === bundle_group.val) {
                      already_in = true;
                      break;
                    }
                  }
                  if (!already_in) {
                    this.d_researchInterests.push(bundle_group)
                  }
                }


                let author_list = [];
                try {
                  author_list = dataset_item.wdmr.data['0']['57']['list'];
                } catch {}
                if (author_list.length > 0) {
                  for (let author_item of author_list) {
                    let author_orcid_id = ''
                    try {
                      author_orcid_id = author_item['63']['val']
                    } catch {}
                    // console.log('author_orcid_id: ',author_orcid_id)

                    if (author_orcid_id !== this.d_userProfileData.orcid_id) {
                      let already_in = false;
                      for (let co_author_item of this.d_coAuthors) {
                        if (author_orcid_id === co_author_item['author_orcid_id']) {
                          already_in = true;
                          break;
                        }
                      }
                      if (!already_in) {
                        let record_author = {
                          'author_firstname': '',
                          'author_lastname': '',
                          'author_title': '',
                          'author_institution': '',
                          'author_orcid_id': '', 
                        }
                        try {
                          record_author.author_firstname = author_item['58']['val']
                        } catch {}
                        try {
                          record_author.author_lastname = author_item['59']['val']
                        } catch {}
                        try {
                          record_author.author_title = author_item['60']['val']
                        } catch {}
                        try {
                          record_author.author_institution = author_item['62']['lang']
                        } catch {}
                        try {
                          record_author.author_orcid_id = author_item['63']['val']
                        } catch {}
                        this.d_coAuthors.push(record_author)
                      }

                    }
                  }

                }

              }
            }
            if (this.d_userDatasetAndArticleList.article_list.length > 0) {
              for (let article_item of this.d_userDatasetAndArticleList.article_list) {

                let artcl_item_bundle = article_item.bundle;
                let bundle_group = {};
                try {
                  bundle_group = artcl_item_bundle.wdmr.data['0']['10']
                } catch {}
                if (bundle_group.val) {
                  let already_in = false;
                  for (let interest_item of this.d_researchInterests) {
                    if (interest_item.val === bundle_group.val) {
                      already_in = true;
                      break;
                    }
                  }
                  if (!already_in) {
                    this.d_researchInterests.push(bundle_group)
                  }
                }
                let artcl_item_article = article_item.article;
                let author_list = [];
                try {
                  author_list = artcl_item_article['66']['list'];
                } catch {}
                if (author_list.length > 0) {

                  for (let author_item of author_list) {
                    let author_orcid_id = ''
                    try {
                      author_orcid_id = author_item['72']['val']
                    } catch {}

                    if (author_orcid_id) {
                      let already_in = false;
                      for (let co_author_item of this.d_coAuthors) {
                        if (author_orcid_id === co_author_item['author_orcid_id']) {
                          already_in = true;
                          break;
                        }
                      }
                      if (!already_in) {
                        let record_author = {
                          'author_firstname': '',
                          'author_lastname': '',
                          'author_title': '',
                          'author_institution': '',
                          'author_orcid_id': '', 
                        }
                        try {
                          record_author.author_firstname = author_item['67']['val']
                        } catch {}
                        try {
                          record_author.author_lastname = author_item['68']['val']
                        } catch {}
                        try {
                          record_author.author_title = author_item['69']['val']
                        } catch {}
                        try {
                          record_author.author_institution = author_item['71']['lang']
                        } catch {}
                        try {
                          record_author.author_orcid_id = author_item['72']['val']
                        } catch {}
                        this.d_coAuthors.push(record_author)
                      }

                    }
                  }

                }

              }
            }

          } else {
            alert(resp.data.status_code + ' = ' + resp.data.status_message);
          }
        });
    }
  },
  watch:{}

}

</script>

<style>

.profile-page {
  min-height: 750px;
  background: #f6f8fb;
  padding-top: 30px;
}

/* PROFILE CARD */
.profile-card {
  border-radius: 18px;
  border: none;
  box-shadow: 0 10px 25px rgba(0,0,0,0.08);
  margin-bottom: 20px;
}

/* AVATAR */
.avatar {
  height: 100px;
  width: 100px;
  border-radius: 50%;
  background: linear-gradient(135deg, #28a745, #20c997);
  display: flex;
  justify-content: center;
  align-items: center;
  color: white;
  font-size: 36px;
  font-weight: bold;
  margin: auto;
  box-shadow: 0 6px 15px rgba(0,0,0,0.2);
}

/* PROFILE TEXT */
.profile-name {
  margin-bottom: 4px;
  font-weight: 600;
}

.profile-mail {
  color: #6c757d;
}

.profile-params {
  margin-top: 6px;
  font-size: 14px;
  color: #495057;
}

/* SOCIAL ICONS */
.social-icons {
  margin-top: 12px;
}

.social-icons a {
  margin-right: 12px;
  font-size: 18px;
  color: #495057;
  transition: all 0.2s ease;
}

.social-icons a:hover {
  color: #28a745;
  transform: translateY(-2px);
}

.social-icons .orcid {
  font-weight: 600;
  font-size: 14px;
}

/* TABS */
.profile-tabs {
  border-radius: 0 0 18px 18px;
  box-shadow: 0 10px 25px rgba(0,0,0,0.06);
}

/* CONTENT CARD */
.content-card {
  border-radius: 14px;
  border: none;
  margin-bottom: 16px;
  transition: all 0.2s ease;
  box-shadow: 0 4px 12px rgba(0,0,0,0.05);
}

.content-card:hover {
  transform: translateY(-3px);
  box-shadow: 0 10px 25px rgba(0,0,0,0.1);
}

.content-card h5 i {
  font-size: 14px;
  margin-left: 8px;
}

.abstract {
  font-size: 14px;
  margin-top: 10px;
}

.date {
  text-align: right;
  font-size: 12px;
  color: #868e96;
  margin-top: 10px;
}

.co-author-card {
  border-radius: 18px;
  border: none;
  box-shadow: 0 10px 25px rgba(0,0,0,0.08);
  margin-bottom: 0;
}

.interests-card {
  border-radius: 18px;
  border: none;
  box-shadow: 0 10px 25px rgba(0,0,0,0.08);
  margin-bottom: 20px;
}

.card-type-header {
  padding: 8px 16px;
  font-size: 12px;
  font-weight: 600;
  color: #fff;
  border-radius: 14px 14px 0 0;
}

/* DATASET – hızlı solan mavi */
.dataset-header {
  background: linear-gradient(
    90deg,
    #3b82f6 0%,
    rgba(59, 130, 246, 0.75) 20%,
    rgba(59, 130, 246, 0.4) 40%,
    rgba(59, 130, 246, 0.15) 65%,
    rgba(59, 130, 246, 0) 100%
  );
}

/* ARTICLE – hızlı solan yeşil */
.article-header {
  background: linear-gradient(
    90deg,
    #22c55e 0%,
    rgba(34, 197, 94, 0.75) 20%,
    rgba(34, 197, 94, 0.4) 40%,
    rgba(34, 197, 94, 0.15) 65%,
    rgba(34, 197, 94, 0) 100%
  );
}

/* b-card default header çizgisini kapat */
.content-card .card-header {
  border-bottom: none;
  padding: 0;
}
</style>